export interface UserRole {
    isOwner: boolean;
    isBiller: boolean;
}

/**
 * Parses user role data from various formats into a standardized boolean structure.
 *
 * Handles:
 * - JSON strings from Twig templates with "0"/"1" string values
 * - Already parsed objects with string or boolean values
 * - Invalid/malformed input
 *
 * @param rawUserRole - Raw user role data (string, object, or any)
 * @returns Parsed user role with boolean values, or undefined if invalid
 */
export const parseUserRole = (rawUserRole: any): UserRole | undefined => {
    if (!rawUserRole) {
        return undefined;
    }

    let parsed: any = rawUserRole;

    // If it's a string, try to parse as JSON
    if (typeof rawUserRole === 'string') {
        try {
            parsed = JSON.parse(rawUserRole);
        } catch {
            return undefined;
        }
    }

    // Ensure we have an object with the expected properties (not an array)
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) {
        return undefined;
    }

    // Convert string values ("0"/"1"/"true") or boolean values to proper booleans
    return {
        isOwner: parsed.isOwner === '1' || parsed.isOwner === 'true' || parsed.isOwner === true,
        isBiller: parsed.isBiller === '1' || parsed.isBiller === 'true' || parsed.isBiller === true,
    };
};
